import React from 'react'
import { motion } from 'framer-motion'
import './portfolio.css'
import PortFolioItem from './portfolioitem'
import personalProjects, { orgProjects, companyProjects } from './ProjectsArray'
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations'
import CompanyProjectCard from './CompanyProjectCard'
import OrgProjectCard from './OrgProjectCard'

const Portfolio = () => {
  const renderPortfolioItems = projects => {
    return projects.map((project, index) => (
      <motion.div
        key={project.id}
        variants={staggerItem}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
      >
        <PortFolioItem data={project} />
      </motion.div>
    ))
  }

  const renderSection = (title, projects) => (
    <motion.div
      className="container portfolio__container"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <motion.h3 className="portfolio__heading" variants={fadeInUp}>
        {title}
      </motion.h3>
      <motion.div
        className="portfolio__section"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {renderPortfolioItems(projects)}
      </motion.div>
    </motion.div>
  )

  return (
    <motion.section
      id="portfolio"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.h5 variants={fadeInUp}>My Recent Works</motion.h5>
      <motion.h2 variants={fadeInUp}>Portfolio</motion.h2>

      {/* Personal Projects */}
      {renderSection('My Personal Projects', personalProjects)}

      {/* Organizational Projects */}
      {orgProjects && orgProjects.length > 0 && (
        <motion.div
          className="container portfolio__container portfolio__org-container"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="portfolio__heading" variants={fadeInUp}>
            Organizational Projects
          </motion.h3>
          <motion.p className="portfolio__org-note" variants={fadeInUp}>
            Projects built during organizational engagements — shared for reference only, no source code or live links.
          </motion.p>
          <motion.div
            className="portfolio__org-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {orgProjects.map((project, index) => (
              <motion.div
                key={project.id}
                variants={staggerItem}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
              >
                <OrgProjectCard data={project} />
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      )}

      {/* Company Projects */}
      {companyProjects && companyProjects.length > 0 && (
        <motion.div
          className="container portfolio__container portfolio__company-container"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="portfolio__heading" variants={fadeInUp}>
            Company Projects
          </motion.h3>
          <motion.p className="portfolio__company-note" variants={fadeInUp}>
            Projects built during professional engagements. Demo videos below — source code protected under NDA.
          </motion.p>
          <motion.div
            className="portfolio__company-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {companyProjects.map((project, index) => (
              <motion.div
                key={project.id}
                variants={staggerItem}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
              >
                <CompanyProjectCard data={project} />
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      )}
    </motion.section>
  )
}

export default Portfolio